import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

// Create a language detector that first checks user settings in localStorage,
// then falls back to browser settings
const languageDetector = new LanguageDetector();
languageDetector.init({
  order: ["localStorage", "navigator"],
  lookupLocalStorage: "i18nextLng",
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
